import { flow, Instance, types } from 'mobx-state-tree'
import { addBankCode } from '../../network/addBankCode'
import { bankCodeProcessApprovals } from '../../network/bankCodeProcessApprovals'
import { deleteBankingCode } from '../../network/deleteBankingCode'
import { getAllBankCodes } from '../../network/getAllBankCodes'
import { getBankCodeById } from '../../network/getBankCodeById'
import { getBankCodeDetails } from '../../network/getBankCodeDetails'
import { updateBankingCode } from '../../network/updateBankingCode'
import { getErrorMessage, MessageTypes } from '../../utils'
import { FORM_MESSAGE } from '../../utils/constants'
import { RootStore } from '../store'

export const BankCode = types.model('BankCode', {
  id: types.maybeNull(types.number),
  code: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  extraField1: types.optional(types.string, ''),
  extraField2: types.optional(types.string, ''),
})
const BankingCodes = types
  .model('BankingCodes', {
    bankCode: BankCode,
    bankCodes: types.array(BankCode),
  })
  .actions((self) => ({
    fetchBankingCodeById: flow(function* fetchBankingCodeById(id: number) {
      try {
        const response = yield getBankCodeById(id, RootStore.session.getTokens)
        const own = self
        own.bankCode = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    getAllBankingCodes: flow(function* getAllBankingCodes(data: any, paginationInfo: any) {
      try {
        const response = yield getAllBankCodes(data, paginationInfo)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    getBankingCode: flow(function* getBankingCode(id: any) {
      try {
        const response = yield getBankCodeDetails(id, RootStore.session.getTokens)
        if (self?.bankCodes?.length === 0) {
          self.bankCodes.push(JSON.parse(JSON.stringify(response)))
        } else {
          const users: any = self?.bankCodes?.map((item: any) => {
            if (id === response.id) {
              return response
            } else {
              return item
            }
          })
          self.bankCodes = users
        }

        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    addBankingCode: flow(function* addBankingCode(data: any) {
      try {
        const response = yield addBankCode(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message ?? 'Added Banking Code', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),

    deleteBankCode: flow(function* deleteBankCode(id) {
      try {
        const response = yield deleteBankingCode(id, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message ?? 'Deleted Banking Code', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),

    updateBankCode: flow(function* updateBankCode(data: any) {
      try {
        const response = yield updateBankingCode(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message ?? 'Updated Banking Code', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield bankCodeProcessApprovals(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message ?? '', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getCodes() {
      return self.bankCodes.map((item) => {
        return {
          ID: item.id,
          ...item,
        }
      })
    },
    getBankingCodeById(id: any) {
      return self.bankCodes?.filter((item) => item?.id?.toString() === id?.toString())?.[0] ?? {}
    },
    getFilteredBankingCodesList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.bankCodes ?? []
      const data = list?.map((item: any) => {
        return {
          ID: item.id,
          ...item,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return list?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const bankingCodeData = BankingCodes.create({
  bankCodes: [],
  bankCode: {},
})

export type BankingCodeType = Instance<typeof BankingCodes>
export { bankingCodeData, BankingCodes }
